import React, { Component } from 'react';
import styled from 'styled-components';
import CardHeader from '../../../../components/CardHeader';
import Card from '../../../../components/Card';
import LineGraph from '../../../../components/Charts/LineGraph';
import IndicatorBox from '../../../../components/IndicatorBox';
import get from 'lodash/get';
import ExportButton from '../../../../components/Export';
import SelectFilter from '../../../../components/Select/SelectFilter';
import Select from '../../../../components/Select';
import { formatParam } from '../../../../utils/formatParam';
import { I18n } from 'react-redux-i18n';

const isMobile = window.innerWidth <= 845;

const TravelLineGraphCardContainer = styled.div`
  .card-header {
    display: inline-flex;
    justify-content: center;
    align-items: center;
    gap: 20px;

    @media (max-width: 845px) {
      display: block;
      gap: 16px;
    }
  }

  .exportButtonContainer {
    padding-bottom: 10px;
    margin-top: 10px;
  }

  .tlgTitle span {
    color: #e25c32;
    margin-right: 10px;
  }

  .tlgTitle {
    text-align: center;
    white-space: normal;

    @media (max-width: 845px) {
      font-size: 16px;
    }
  }

  .tlgIndicatorsContainer {
    height: 300px;
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-gap: 10px;
    margin-top: 20px;

    @media (max-width: 1200px) {
      width: 100%;
      display: grid;
      grid-template-columns: 1fr 1fr;
      grid-gap: 10px;
      height: auto;
    }

    @media (max-width: 845px) {
      margin-top: 0;
      grid-template-columns: 1fr;
    }

    .title {
      font-size: 20px !important;
      font-weight: 600;
      line-height: 24px;
    }

    * {
      font-size: 14px !important;
    }
  }

  .tlgContentContainer {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-gap: 20px;

    @media (max-width: 1200px) {
      grid-template-columns: 1fr;
    }
  }

  .selectSetsContainer {
    width: 80%;
    margin-left: 10%;

    @media (max-width: ${(props) =>
        props.theme.devices.isTablet ? '0px' : '845px'}) {
      margin: 0;
      width: 100%;
    }
  }

  .recharts-cartesian-axis-tick-value {
    font-size: 12px;
    font-family: SFCompactText;
    fill: #1f2b37;
  }

  .tlgGraphContainer {
    padding-top: 20px;
    margin-left: -40px;
    padding-bottom: 10px;
  }

  .filter {
    @media (min-width: 845px) {
      min-width: 180px;
      max-width: 300px;
    }
  }
`;

class TravelLineGraphCard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      wine: null,
      tagList: []
    };
  }

  componentDidMount() {
    if (this.props.wineOptions.length > 0) {
      this.setState({ wine: this.props.wineOptions[0], tagList: [] });
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps != this.props && this.props.wineOptions.length > 0) {
      this.setState({ wine: this.props.wineOptions[0], tagList: [] });
    }
  }

  renderHeader() {
    const { wine } = this.state;
    const colors = this.getColors();
    const { title, name, exportOptions } = this.props;

    const exportOptionsWithWine = {
      ...exportOptions,
      options: {
        ...exportOptions.options,
        wines: formatParam(JSON.stringify([get(wine, 'label')]))
      }
    };

    return (
      <CardHeader
        title={
          <div className="card-header">
            <h1 className="tlgTitle">{title}</h1>
          </div>
        }
        fontSize="20px"
        iconColor="#e25c32"
        iconRight
        alignItems="center"
        rightComponents={
          <ExportButton
            jpg
            pdf
            xls
            colors={colors}
            {...exportOptionsWithWine}
            targetElement={`#voyage-distribution-${name}`}
            name={title}
            newApi
          />
        }
      />
    );
  }

  formatIndicators() {
    const indicators = this.props.indicators || [];
    const { tooltipLabel, nameMarket, isBranded, isChampagne } = this.props;
    const { wine } = this.state;
    if (indicators && indicators.length > 0) {
      let indicator = wine
        ? indicators.find((item) =>
            isBranded
              ? item.marque_name === wine.label
              : item.wine_name === wine.label
          )
        : indicators[0];
      if (indicator) {
        return [
          {
            title: indicator.dn,
            content: `${tooltipLabel} ${I18n.t('at')} ${nameMarket}`
          },
          {
            title: indicator.new,
            content: I18n.t('travel.indicators.won')
          },
          {
            title: indicator.avg_price
              ? indicator.avg_price.toLocaleString('fr-FR', {
                  style: 'currency',
                  currency: indicator.displayed_currency
                    ? indicator.displayed_currency
                    : 'EUR',
                  minimumFractionDigits: 0,
                  maximumFractionDigits: 0
                })
              : // based on avg_price_post_90 as per API and JSON translation file
                indicator.avg_price_recent_vintage
                ? indicator.avg_price_recent_vintage.toLocaleString('fr-FR', {
                    style: 'currency',
                    currency: indicator.displayed_currency
                      ? indicator.displayed_currency
                      : 'EUR',
                    minimumFractionDigits: 0,
                    maximumFractionDigits: 0
                  })
                : '-',
            content: isChampagne
              ? I18n.t('averagePrice')
              : I18n.t('travel.indicators.average')
          },
          {
            title: indicator.lost,
            content: I18n.t('travel.indicators.lost')
          },
          !isBranded && {
            title: indicator.frequent_vintage,
            content: I18n.t('travel.indicators.vintage')
          },
          !isBranded && {
            // based in post_90, as per API and JSON translation file
            title: indicator.dn_old_vintage,
            content: `${tooltipLabel} ${I18n.t('travel.indicators.oldVintage')}`
          }
        ].filter((item) => !!item);
      }
    }
    return [];
  }

  formatData() {
    const dataChart = this.props.dataChart || [];
    const { wine } = this.state;
    let formattedData = [...dataChart];
    formattedData = wine
      ? formattedData.filter((item) => item.name === wine.label)
      : formattedData.filter(
          (item) => item.name === get(formattedData, '[0].name')
        );
    formattedData = [formattedData];
    let { tagList } = this.state;
    tagList = tagList.map((item) => item.label);
    tagList.forEach((tag) => {
      formattedData.push(dataChart.filter((item) => item.name == tag));
    });

    formattedData = formattedData.map((set) =>
      set
        .map((item) => ({
          name: item.year,
          value: item.dn ? item.dn : 0,
          wine: item.name
        }))
        .sort((a, b) => Number(a.name) - Number(b.name))
    );
    let setNames = [];
    let wines = [];
    formattedData.forEach((set) => {
      if (set && set.length > 0) {
        set.sort(function (a, b) {
          return String(a.name).localeCompare(String(b.name));
        });
        setNames.push(...set.map((item) => item.name));
        wines.push(set[0].wine);
      }
    });
    setNames = [...new Set(setNames)].sort();

    formattedData.forEach((set, setIndex) => {
      setNames.forEach((name, index) => {
        if ((!set[index] && set[index] !== 0) || set[index].name !== name) {
          set.splice(index, 0, {
            name,
            wine: wines[setIndex],
            value: 0
          });
        }
      });
    });

    formattedData.forEach((set) => {
      set.forEach((wine) => {
        wine.name =
          wine.name == 9999 ? I18n.t('travel.now') : wine.name.toString();
      });
    });
    return formattedData;
  }

  getLabels(data) {
    if (data && data.length > 0) {
      return data
        .filter((item) => item && item.length > 0)
        .map((set) => set[0].wine);
    }
    return [];
  }

  renderSelectSets(rivals) {
    return (
      <div className="selectSetsContainer ignored-export">
        <Select
          placeholder={I18n.t('placeholderRivals')}
          isMulti
          value={this.state.tagList}
          dropdownProps={{
            styles: `margin-left:20px;margin-right:20px;`
          }}
          onChange={(value) =>
            this.setState({
              tagList:
                value && value.length > 5 ? value.slice(1, value.length) : value
            })
          }
          options={rivals.map((item) => ({ value: item, label: item }))}
        />
      </div>
    );
  }

  getRivals() {
    const { client_wines, client_brands, isBranded } = this.props;
    const { wine } = this.state;
    if (isBranded) {
      return client_brands && client_brands.length > 0 && wine
        ? get(
            client_brands.find((item) => item.marque_name === wine.label),
            'rivals',
            []
          )
        : [];
    }
    return client_wines && client_wines.length > 0 && wine
      ? get(
          client_wines.find((item) => item.wine_name === wine.label),
          'rivals',
          []
        )
      : [];
  }

  getColors() {
    return [
      '#e25d34',
      '#1f2b37',
      '#C9D0D6',
      '#b7bbbf',
      '#dbdddf',
      '#C4C8CC',
      '#D5D9DE',
      '##E1E6EB'
    ];
  }

  render() {
    const indicators = this.formatIndicators();
    const { wineOptions, isBranded, name } = this.props;
    const { wine } = this.state;
    let rivals = this.getRivals();
    const formattedData = this.formatData();
    const labels = this.getLabels(formattedData);
    const colors = this.getColors();

    return (
      <TravelLineGraphCardContainer>
        <Card id={`travel-distribution-${name}`}>
          {this.renderHeader()}
          <div className="filter">
            <SelectFilter
              value={wine}
              options={wineOptions}
              onChange={(value) => this.setState({ wine: value, tagList: [] })}
              label={
                isBranded
                  ? I18n.t('synthesisDistribution.filters.brand')
                  : I18n.t('wineMaj')
              }
              isClearable={false}
            />
          </div>
          <div className="tlgContentContainer">
            <div className="tlgLeftContent">
              <div className="tlgGraphContainer">
                <LineGraph
                  height={400}
                  data={formattedData}
                  labels={labels}
                  yAxisProps={{
                    scale: 'linear',
                    domain: [
                      0,
                      (dataMax) =>
                        Number(dataMax + dataMax / 2).toFixed(0) > 5
                          ? Number(dataMax + dataMax / 2).toFixed(0)
                          : 5
                    ]
                  }}
                  tooltipOffset={{ x: 0, y: 70 - 20 * formattedData.length }}
                  acceptZeros
                  strokeDasharray={[null, ['5 5'], ['5 5']]}
                  colors={colors}
                />
              </div>
              {this.renderSelectSets(rivals)}
            </div>
            <div className="ignored-export">
              <div className="tlgIndicatorsContainer">
                {indicators.map((indicator, index) => (
                  <IndicatorBox
                    {...indicator}
                    key={`${indicator.title}-${index}`}
                    styles={{ padding: isMobile ? 16 : 20 }}
                    sizeTitle="30px"
                    sizeContent="16px"
                  />
                ))}
              </div>
            </div>
          </div>
        </Card>
      </TravelLineGraphCardContainer>
    );
  }
}

export default TravelLineGraphCard;
